import React from 'react';

import hoursApi from '../api/hours';
import timeHelper from '../helpers/time';
import View from './view.jsx';
import './App.css';


const Loader = () => (
    <header className="App-header">
        <p>
            Requesting data ...
        </p>
    </header>
);

class App extends React.Component {
    constructor(props) {
        super(props);
        this.onMonthChange = this.onMonthChange.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this._buildComparativeHoursData = this._buildComparativeHoursData.bind(this);
        this.state = {
            data: {},
            projectsData: [],
            comparativeHoursData: [],
            yearSelected: null,
            monthSelected: null,
            agreementHours: null,
        }
    }

    _buildPieChartData(data) {
        const projectsData = {};
        const projectTypes = data.data.projectTypes;

        Object.keys(projectTypes).map((projectType) => {
            const projects = projectTypes[projectType].projects;

            Object.keys(projects).map((projectCode) => {
                const projectData = projects[projectCode];
                if (!(projectsData[projectCode])) {
                    projectsData[projectCode] = {
                        hoursSpentOnBugs: 0,
                        totalHours: 0,
                        projectName: projectData.projectName,
                    };
                }

                projectsData[projectCode].hoursSpentOnBugs += projectData.hoursSpentOnBugs;
                projectsData[projectCode].totalHours += projectData.totalHours;
            });
        });

        return projectsData;
    }

    _buildComparativeHoursData(data) {
        return Object.keys(data?.agreementHours?.days || {}).map((day) => {
            const agreementHour = parseFloat(data.agreementHours.days[day]);
            const hoursDone = timeHelper.secondsToHour(data.data.days[day]?.totalTimeSpent || 0);

            return {
                name: `Day: ${day}`,
                agreementHour,
                hoursDone,
            }
        });

    }

    fetchData() {
        hoursApi.getAll({
            email: this.props.email,
            year: this.state.yearSelected,
            month: this.state.monthSelected,
        })
            .then((response) => {
                this.setState({
                    ...response,
                    projectsData: this._buildPieChartData(response),
                    comparativeHoursData: this._buildComparativeHoursData(response),

                });
            })
            .catch((error) => {
                console.log(error);
            });
    }

    componentDidMount() {
        if (Object.keys(this.state.data).length === 0) {
            this.fetchData();
        }
    }

    onMonthChange(year, month) {
        this.setState({
            yearSelected: year,
            monthSelected: month,
            data: {},
        }, () => {
            this.fetchData();
        });
    }

    render() {
        const date = new Date();
        const isCurrentMonth = this.state?.monthSelected === date.getMonth() + 1;

        if (Object.keys(this.state.data).length > 0) {
            return <View
                {...this.state}
                onMonthChange={this.onMonthChange}
                isCurrentMonth={isCurrentMonth}
            />;
        } else {
            return <Loader />;
        }
    }
}

export default App;
